import { useOrganization } from "../../store/organization";
import {BookButton} from "./BookButton";
import {usePartnerLanding} from "../../store/partnerLanding";

export function AboutPartner({toggleZipModalOpen}) {
  const { organization } = useOrganization();
  const partnerLanding = usePartnerLanding();
  const landingDetails = organization.data.landingDetails;

  return (
    <div className="tw-p-3 tw-mt-8 md:tw-mt-20 tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-mx-auto" style={{ maxWidth: 600 }}>
      <h3 className="tw-text-2xl tw-font-bold tw-pb-2 tw-text-center">{landingDetails.blurb.headerText}</h3>
      <h4 className="tw-text-xl tw-font-bold tw-pb-8 tw-text-center">{landingDetails.blurb.subHeader}</h4>

      {landingDetails.blurb.descriptionParts.map((description, key) => (
        <p className="tw-whitespace-pre-line tw-pb-6" key={key}>{description}</p>
      ))}

      {!partnerLanding.isMobile && <BookButton color="black" onClick={toggleZipModalOpen}/>}
    </div>
  );
}
